import React from 'react';
import { Provider } from 'react-redux';
import Store from './Redux';
import Container from './Pages'
const ReduxStore = Store();


function App(props) {
return (
        <Provider store={ReduxStore}>
            <Container/>
        </Provider>
    )
}

export default App;
